export default __webpack_public_path__ + "static/social-share-7fefc6c6d3b853fe0f99c99bf1d9c66a.png";